// Re-export core widget for convenience
export * from '@examdojo/core/widget';

// Export concrete widget implementations
export * from './widgets';

// Export widget registry and initialization
export * from './widgets/registry';
export * from './widgets/widget-initializer';

// Export dashboards (stores, generators)
export * from './dashboards';
